import { FC, useMemo, useState } from 'react';
import { Layout } from 'features/Layouts/Layouts';
import { MainTitle } from 'components/MainTitle';
import { useGetPerformersWorkSupportQuery } from 'redux/Api/performersWorkSupport/performersWorkSupport';
import { PerformersList } from 'components/PerformersList';
import { InputSearch } from 'ui/InputSearch';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import styles from './PerformersContent.module.scss';

export const PerformersContent: FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const { data, isLoading } = useGetPerformersWorkSupportQuery();

  const filtredArr = useMemo(() => {
    if (!data?.items) return [];
    return data.items.filter(
      (elem) =>
        elem?.fioI
          ?.replaceAll(' ', '')
          ?.toLowerCase()
          ?.includes(searchValue.replaceAll(' ', '').toLowerCase()) ||
        elem?.fioF
          ?.replaceAll(' ', '')
          ?.toLowerCase()
          ?.includes(searchValue.replaceAll(' ', '').toLowerCase()) ||
        elem?.fioO
          ?.replaceAll(' ', '')
          ?.toLowerCase()
          ?.includes(searchValue.replaceAll(' ', '').toLowerCase()) ||
        elem?.phone
          ?.replaceAll(' ', '')
          ?.toLowerCase()
          ?.includes(searchValue.replaceAll(' ', '').toLowerCase()),
    );
  }, [data?.items, searchValue]);

  return (
    <Layout>
      <div className={styles.root}>
        <MainTitle title='Модерация' count={data?.count} />
        <div className={styles.root_search}>
          <div className={styles.root_search_item}>
            <InputSearch
              notFocus
              placeholder='Искать'
              value={searchValue}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSearchValue(e.target.value)
              }
            />
          </div>
        </div>
        {isLoading ? <LoadingSkeleton /> : <PerformersList data={filtredArr} />}
      </div>
    </Layout>
  );
};
